/**
 * Support widget — payload validation.
 *
 * A malformed payload is indistinguishable from an outage as far as the UI is concerned,
 * so it takes the same path: anything that is not recognisably this contract is treated
 * as closed (see `fallback.ts`).
 *
 * The check is deliberately shallow — `state` and `channels` are what every surface
 * branches on, and everything downstream reads defensively anyway. A stricter check here
 * would start rejecting payloads that a newly deployed backend field made "unfamiliar",
 * which is the opposite of what a fail-closed guard is for.
 */
import type { SupportApiResponse, SupportAvailability } from "./api.types"
import { SUPPORT_AVAILABILITIES } from "./api.types"

export function isSupportAvailability(value: unknown): value is SupportAvailability {
  return SUPPORT_AVAILABILITIES.indexOf(value as SupportAvailability) !== -1
}

export function isSupportApiResponse(raw: unknown): raw is SupportApiResponse {
  const candidate = raw as SupportApiResponse

  return (
    Boolean(candidate) &&
    typeof candidate === "object" &&
    isSupportAvailability(candidate.state) &&
    Boolean(candidate.channels)
  )
}
